var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getMerchant.theme == 'ZOO')?_c('PaymentResult'):(_vm.getMerchant.is_special_merchant)?_c('NormalTemplateV2'):_c('NormalTemplate')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6baa3c90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ticket/TicketOrderHistoryDetailWrapper.vue
// module id = null
// module chunks = 